module.exports = __webpack_public_path__ + "static/media/certificate.65172a8e.svg";